import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SwalService } from "@shared/utils/swal.service";
import { EmpresasService } from "@p-parametria/mantenimiento/abc-empresas/services/empresas.service";
import { Table } from "primeng/table";
import { AbcEmpresasFormComponent } from "./components/abc-empresas-form/abc-empresas-form.component";
import Swal from "sweetalert2";

interface Column {
    field: string;
    header: string;
}

@Component({
    selector: "app-abc-empresas",
    templateUrl: "./abc-empresas.component.html",
    styleUrls: ["./abc-empresas.component.css"],
})
export class AbcEmpresasComponent implements OnInit {
    @ViewChild("dt") table: Table;

    private readonly _width: string = "380px";
    dataSource: any[] = [];
    loading: boolean = false;
    allData: number = 0;

    valueToSearch: string = "";

    columns: Column[] = [
        { field: "sEmpresa", header: "Clave" },
        { field: "sNombre", header: "Empresa" },
        { field: "responsable", header: "Responsable" },
        { field: "telefono", header: "Teléfono" },
        { field: "sTipo", header: "Tipo" },
        { field: "actions", header: "Acciones" },
    ];

    constructor(private empresaServices: EmpresasService, public _dialog: MatDialog, private _swalService: SwalService) {}

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.loading = true;
        this.empresaServices.GetEmpresas().subscribe({
            next: (response) => {
                if (response.success) {
                    this.dataSource = response.data;
                    if (response.data) this.allData = response.data.length;
                } else {
                    console.error('Error al cargar empresas:', response);
                    this._swalService.error('Error al cargar la lista de empresas');
                }
                this.loading = false;
            },
            error: (error) => {
                console.error('Error al cargar empresas:', error);
                this._swalService.error('Error al cargar la lista de empresas');
                this.loading = false;
            }
        });
    }

    nuevo(): void {
        const dialogRef = this._dialog.open(AbcEmpresasFormComponent, {
            width: '60%',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadData();
            }
        });
    }

    editar(row: any): void {
        const dialogRef = this._dialog.open(AbcEmpresasFormComponent, {
            width: '60%',
            data: row,
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadData();
            }
        });
    }

    delete(row: any) {
        Swal.fire({
            title: '¿Está seguro?',
            text: `¿Está seguro de eliminar la empresa ${row.sNombre}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: "#d33",
            iconColor: "#d33",
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'No',
            heightAuto: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.empresaServices.DeleteEmpresa(row.sEmpresa).subscribe({
                    next: (response) => {
                        if (response.success) {
                            this._swalService.success('Empresa eliminada correctamente');
                            this.loadData();
                        } else {
                            this._swalService.error('Error al eliminar la empresa');
                        }
                    },
                    error: (error) => {
                        console.error('Error al eliminar empresa:', error);
                        this._swalService.error('Error al eliminar la empresa');
                    }
                });
            }
        });
    }
}
